import React from 'react';
import { DetailRow } from './DetailRow';
import type { PaymentDetail } from '../../types/panel-common.types';


interface DetailsListProps {
  details: PaymentDetail[];
  isDetailView?: boolean;
  specialRenderer?: (detail: PaymentDetail, index: number, isLast: boolean) => React.ReactNode;
  /** Horizontal alignment of each row's value column. Defaults to 'left'. */
  align?: 'left' | 'right';
}

export const DetailsList = React.memo<DetailsListProps>(({ 
  details, 
  isDetailView = false,
  specialRenderer,
  align = 'left'
}) => {
  return (
    <div className="flex flex-col gap-3">
      {details.map((detail, index) => {
        // Use special renderer if provided
        if (specialRenderer) {
          const isLast = index === details.length - 1;
          const specialContent = specialRenderer(detail, index, isLast);
          if (specialContent) {
            return <React.Fragment key={detail.label}>{specialContent}</React.Fragment>;
          }
        }
        
        // Default rendering with DetailRow - no wrapper needed
        return (
          <DetailRow 
            key={detail.label}
            label={detail.label} 
            value={detail.value} 
            isDetailView={isDetailView}
            showBadge={detail.showBadge}
            badgeVariant={detail.badgeVariant}
            isCopyable={detail.isCopyable}
            align={align}
          />
        );
      })}
    </div>
  );
});

DetailsList.displayName = 'DetailsList';
